// node_modules
import {
  FC,
  useContext,
  useState,
  useCallback
} from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import Modal from "react-modal";
// Components
import {
  Cases,
  NotFound,
  TechnologyReferenceModalContent,
  TopbarMenu
} from "./Components";
// styles
import styles from "./app.module.scss";
// Context
import { CaseStore, AuthContext } from "./Stores";
import { UserProvider } from "Providers";
// Helpers
import { ReferenceHelperSingleton } from "./Helpers";
// Types
import { TReference } from "Types";
// Custom hooks
import { useHash } from "Hooks";
import { PendoHelperSingleton } from "Helpers";

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement("#root");

const App: FC = () => {
  // Contexts
  const { authState } = useContext(AuthContext);

  // State
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [reference, setReference] = useState<TReference | undefined>(undefined);
  
  // Logic
  // When URL's hash change (user clicked on a reference for example), 
  // then display reference details in the modal.
  const hashChangeHandler = useCallback((): void => {
    const ref: TReference | undefined = ReferenceHelperSingleton.getReferenceFromHash(window.location.hash);
    if (ref) {
      setReference(ref);
      setIsModalOpen(true);
    }
  }, []);

  // Custom hooks
  const { removeHashFromURL } = useHash(hashChangeHandler);

  // Logic
  const closeModal = (): void => {
    setReference(undefined);
    setIsModalOpen(false);
    removeHashFromURL();
  };

  PendoHelperSingleton.initializePendo(authState.userEmail, authState.organizationName);

  // Render
  return (
    <>
      {authState.antiForgeryToken ?
        <UserProvider>
          <div className={styles.app}>
            <Router>
              <TopbarMenu />
              <Switch>
                <Route path="/cases/:caseId(\d+)">
                  <CaseStore>
                    <Modal
                      isOpen={isModalOpen}
                      onRequestClose={closeModal}
                      className={styles.appModalContent}
                      overlayClassName={styles.appModalOverlay}
                    >
                      <TechnologyReferenceModalContent reference={reference} closeModal={closeModal} />
                    </Modal>
                    <Cases />
                  </CaseStore>
                </Route>
                <Route>
                  <NotFound />
                </Route>
              </Switch>
            </Router>
          </div>
        </UserProvider>
      :
        null
      }
    </>
  );
};

export default App;
